'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct5 from "./scala.-Product5.js";
var $p;
/** @constructor */
function $c_T5(_1, _2, _3, _4, _5) {
  this.pN = null;
  this.pO = null;
  this.pP = null;
  this.pQ = null;
  this.pR = null;
  this.pN = _1;
  this.pO = _2;
  this.pP = _3;
  this.pQ = _4;
  this.pR = _5;
}
export { $c_T5 as $c_T5 };
$p = $c_T5.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T5;
/** @constructor */
function $h_T5() {
}
export { $h_T5 as $h_T5 };
$h_T5.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 5;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct5.$f_s_Product5__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, 417360321, true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T5) && (((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pN, x$0.pN) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pO, x$0.pO)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pP, x$0.pP)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pQ, x$0.pQ)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pR, x$0.pR))));
});
$p.o = (function() {
  return "Tuple5";
});
$p.b = (function() {
  return (((((((((("(" + this.pN) + ",") + this.pO) + ",") + this.pP) + ",") + this.pQ) + ",") + this.pR) + ")");
});
function $isArrayOf_T5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eP)));
}
export { $isArrayOf_T5 as $isArrayOf_T5 };
var $d_T5 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T5, "scala.Tuple5", ({
  eP: 1,
  b: 1,
  c: 1,
  rY: 1,
  a: 1
}));
export { $d_T5 as $d_T5 };
